import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_roen_11: FaireProductEntity = {
  token: "legacy_prod_roen-11",
  type: "product",
  name: "Bar Monti",
  brandName: "ROEN",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/d076b8f16aa44cb54a5ae446a25b8318235679608f45615ee39e29be16b228f1.webp",
  priceDollars: 18,
  msrpDollars: 36,
  freeShipping: true,
  brandAvatarUrl: "/images/ROEN/Brand%20Page/roen-avatar.webp",
  weight: 0.5,
  dimensions: {
    width: 3,
    height: 4,
    depth: 2,
  },
  brandToken: "catalog_brand_roen",
  description: "Premium candle from ROEN.",
  categoryTokens: ["cat_food-snacks"],
  tags: ["candles", "home fragrance", "premium"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
